import { observer } from "mobx-react-lite";
import { LoadingBar, PaginationControls } from "@/components/common";
import { useTran } from "@/hooks";
import { cn } from "@/lib/utils";
import MetricDetailRow from "./MetricDetailRow";
import MetricDetailRowSkeleton from "./skeleton/MetricDetailRowSkeleton";

const MetricDetailPanel = observer(({ panel }) => {
  const { t } = useTran();
  const {
    rows,
    total,
    page,
    pageSize,
    loading,
    hasLoadedOnce,
    setPage,
    setPageSize,
  } = panel;

  const showSkeleton = !hasLoadedOnce && loading;
  const showRefresh = hasLoadedOnce && loading;

  return (
    <div className="relative mb-3 mt-1 overflow-hidden rounded-md border border-border/40 bg-muted/20 p-3">
      {showRefresh && <LoadingBar />}
      <div
        className={cn(
          "space-y-3 transition-opacity",
          showRefresh && "opacity-60",
        )}
      >
        <PaginationControls
          page={page}
          pageSize={pageSize}
          total={total}
          onPageChange={setPage}
          onPageSizeChange={setPageSize}
          pageSizeOptions={[5, 10, 20]}
          disabled={loading}
          listLabel={t("Organizations")}
          hideWhenSinglePage
        />
        {showSkeleton ? (
          <div className="space-y-2">
            {Array.from({ length: pageSize }).map((_, i) => (
              <MetricDetailRowSkeleton key={i} />
            ))}
          </div>
        ) : rows.length === 0 ? (
          <div className="rounded-md border border-dashed border-border/70 p-6 text-center text-sm text-muted-foreground">
            {t("No organizations match your filters.")}
          </div>
        ) : (
          <div className="space-y-2">
            {rows.map((row) => (
              <MetricDetailRow key={row.orgId} row={row} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
});

export default MetricDetailPanel;
